import { Route, Routes, useLocation } from "react-router-dom";
import { ProtectedRoute } from './../../services/ProtectedRoute';

import HomePage from './../../pages/HomePage';
import UsersPage from './../../pages/CommonDataPages/UsersPage';
import PostsPage from './../../pages/PostsPage';
import ExternalPage from './../../pages/ExternalPage';
import CommonData from './../../pages/CommonDataPages/CommonData';
import EquipmentsPage from './../../pages/CommonDataPages/EquipmentsPage';
import HaulMasterLivePage from './../../pages/HaulMasterPages/HaulMasterLivePage';
import LoadLocationsPage from './../../pages/HaulMasterPages/LoadLocationsPage';
import DumpLocationsPage from './../../pages/HaulMasterPages/DumpLocationsPage';
import MaterialsPage from './../../pages/HaulMasterPages/MaterialsPage';
import PreChecksandFormsPage from './../../pages/PreChecksAndForms/PreChecksandFormsPage';
import FuelTypesandSourcesPage from './../../pages/FuelManagementPages/FuelTypesandSourcesPage';
import ShiftsPage from './../../pages/CommonDataPages/ShiftsPage';
import CrewPage from './../../pages/CommonDataPages/CrewPage';
import FLHAPage from './../../pages/PreChecksAndForms/FLHAPage';
import EquipmentPreCheckPage from './../../pages/PreChecksAndForms/EquipmentPreCheck';
import NPTReasonsPage from './../../pages/PreChecksAndForms/NPTReasonsPage';
import EquipmentBreakdownPage from './../../pages/PreChecksAndForms/EquipmentBreakdown/EquipmentBreakdownPage';
import Header from './Header';
import Footer from './Footer';
import { LoginPage } from "./../../pages/auth/LoginPage";
import PlanUpload from "../../pages/PlanUploadPages/PlanUpload";
import AIAssistant from './AIAssistant';
import DispatchUpload from "../../pages/DispatchDatPages/DispatchUploads";
import DocumentsUploadPage from "../../pages/DocumentUploads/DocumentsUploadPage";
import Reports from "../../pages/Reports/Reports";

export const AppLayout = () => {
  const location = useLocation();
  const hideLayout = location.pathname === "/login";

  return (
    <>
      {!hideLayout && <Header />}

      {/* 🔥 Header must be inside Router */}
          <div className="App">
            <Routes>
              {/* Public route */}
              <Route path="/login" element={<LoginPage />} />

              {/* Protected routes */}
              <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
              <Route path="/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
              <Route path="/posts" element={<ProtectedRoute><PostsPage /></ProtectedRoute>} />
              <Route path="/external" element={<ProtectedRoute><ExternalPage /></ProtectedRoute>} />
              <Route path="/commondata" element={<ProtectedRoute><CommonData /></ProtectedRoute>} />
              <Route path="/commondata/equipments" element={<ProtectedRoute><EquipmentsPage /></ProtectedRoute>} />
              <Route path="/haulmasterlive" element={<ProtectedRoute><HaulMasterLivePage /></ProtectedRoute>} />
              <Route path="/loadlocations" element={<ProtectedRoute><LoadLocationsPage /></ProtectedRoute>} />
              <Route path="/dumplocations" element={<ProtectedRoute><DumpLocationsPage /></ProtectedRoute>} />
              <Route path="/materials" element={<ProtectedRoute><MaterialsPage /></ProtectedRoute>} />
              <Route path="/prechecksandforms" element={<ProtectedRoute><PreChecksandFormsPage /></ProtectedRoute>} />
              <Route path="/fueltypesandsources" element={<ProtectedRoute><FuelTypesandSourcesPage /></ProtectedRoute>} />
              <Route path="/commondata/shifts" element={<ProtectedRoute><ShiftsPage /></ProtectedRoute>} />
              <Route path="/commondata/crew" element={<ProtectedRoute><CrewPage /></ProtectedRoute>} />
              <Route path="/prechecksandforms/flha" element={<ProtectedRoute><FLHAPage /></ProtectedRoute>} />
              <Route path="/prechecksandforms/equipmentprecheck" element={<ProtectedRoute><EquipmentPreCheckPage /></ProtectedRoute>} />
              <Route path="/prechecksandforms/nptreasons" element={<ProtectedRoute><NPTReasonsPage /></ProtectedRoute>} />
              <Route path="/prechecksandforms/equipmentbreakdown" element={<ProtectedRoute><EquipmentBreakdownPage /></ProtectedRoute>} />
              <Route path="/planupload" element={<ProtectedRoute><PlanUpload /></ProtectedRoute>} />
              <Route path="/dispatchupload" element={<ProtectedRoute><DispatchUpload /></ProtectedRoute>} />
              <Route path="/documents" element={<ProtectedRoute><DocumentsUploadPage /></ProtectedRoute>} />
              <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            </Routes>
          </div>
          {!hideLayout && <AIAssistant />}
          <Footer />
    </>
  );
};